<template>
  <div class="registration_success">
    <Icon
      type="md-checkmark-circle"
      size="80"
      style="color: #19be6b; margin-bottom: 20px; margin-top: 100px"
    />
    <p style="font-size: 18px">{{ $t('global.text20') }}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.registration_success {
  background-color: #fff;
}
</style>
